import { feature, mesh } from 'topojson-client';
import getBBox from '@turf/bbox';

import Flatbush from '../vendor/flatbush';

const innerCompare = (a: TopoJSON.GeometryObject, b: TopoJSON.GeometryObject) =>
  a !== b;
const outerCompare = (a: TopoJSON.GeometryObject, b: TopoJSON.GeometryObject) =>
  a === b;

function prepareTopoJSON(topology: TopoJSON.Topology, key?: string) {
  const object = topology.objects[
    key || Object.keys(topology.objects)[0]
  ] as TopoJSON.GeometryCollection;
  const roadsObject = topology.objects['roads'] as TopoJSON.GeometryCollection;
  const placesObject = topology.objects[
    'places'
  ] as TopoJSON.GeometryCollection;
  const urbanAreasObject = topology.objects[
    'urban_areas'
  ] as TopoJSON.GeometryCollection;

  const collection = feature(topology, object);
  const roads = feature(topology, roadsObject);
  const places = feature(topology, placesObject);
  const urban_areas = feature(topology, urbanAreasObject);
  // const innerlines = mesh(topology, object, innerCompare);
  // const outerlines = mesh(topology, object, outerCompare);
  const bbox = topology.bbox || getBBox(collection);

  const index = new Flatbush(collection.features.length);
  collection.features.forEach(feature => {
    const bounds = getBBox(feature);
    index.add(...bounds);
  });
  index.finish();

  const heightRatio = (bbox[3] - bbox[1]) / (bbox[2] - bbox[0]);

  return {
    collection,
    // features,
    // innerlines,
    // outerlines,
    bbox,
    heightRatio,
    index,
    roads,
    places,
    urban_areas,
  };
}

export default prepareTopoJSON;